import { FC } from 'react';

import SSRIcon from '@ingka/ssr-icon';
import locationPinIcon from '@ingka/ssr-icon/paths/location-pin';
import mailIcon from '@ingka/ssr-icon/paths/mail';
import personIcon from '@ingka/ssr-icon/paths/person';
import phoneIcon from '@ingka/ssr-icon/paths/phone';
import storeIcon from '@ingka/ssr-icon/paths/store';

import ContactInfo from '../../interfaces/ContactInfo';
import { Address } from '../toolkit';

import FullName from './FullName';

interface IContactInfoProps {
  contactInfo: ContactInfo;
}

const ContactInfoComponent: FC<IContactInfoProps> = ({
  contactInfo: { firstName, middleName, lastName, email, mobileNumber, businessInfo, ...address },
}) => {
  return (
    <div className="ContactInfoComponent text-s">
      {firstName && lastName && (
        <div className="flex mb-75">
          <SSRIcon paths={personIcon} className="mr-75" />
          <FullName firstName={firstName} lastName={lastName} middleName={middleName} />
        </div>
      )}

      {businessInfo && businessInfo.businessName && (
        <div className="flex mb-75">
          <SSRIcon paths={storeIcon} className="mr-75" />
          {businessInfo.businessName}
        </div>
      )}

      {!!email && (
        <div className="flex mb-75">
          <SSRIcon paths={mailIcon} className="mr-75" />
          {email}
        </div>
      )}

      {mobileNumber && (
        <div className="flex mb-75">
          <SSRIcon paths={phoneIcon} className="mr-75" />
          {mobileNumber}
        </div>
      )}

      <div className="flex mb-75">
        <SSRIcon paths={locationPinIcon} className="mr-75" />
        <Address {...address} />
      </div>
    </div>
  );
};

export default ContactInfoComponent;
